import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    window.location.href = 'https://myme.deepstudio.io/';
  }, [])

  return (
    <div className="App">
    </div>
  );
}

export default App;
